import React from 'react';
import { Icon } from './Icon.js';
export const IconBanFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("rect", { x: ".751", y: "5.25", width: "10.499", height: "1.5", transform: "translate(-2.485 6) rotate(-45)", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m6,12c-3.309,0-6-2.691-6-6S2.691,0,6,0s6,2.691,6,6-2.691,6-6,6Zm0-10.5C3.519,1.5,1.5,3.519,1.5,6s2.019,4.5,4.5,4.5,4.5-2.019,4.5-4.5S8.481,1.5,6,1.5Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconBanFill12.js.map